import { axiosInstanceWebsite } from "../instance";
import { AxiosResponse } from "../interface";
import { LogisticState } from "../../types/order/logisticState";
import { decodeTokenService } from "../decodeTokenService";

export interface QueryFiltersParams {
  date_init?: string | null;
  date_end?: string | null;
  product_ids?: string[] | null;
  page?: number;
  size?: number;
}

export const getOrdersByUser = async ({
  date_init,
  date_end,
  product_ids,
  page = 0,
  size = 15,
}: QueryFiltersParams) => {
  const params = new URLSearchParams();
  params.append("page", String(page));
  params.append("size", String(size));

  if (date_init && date_end) {
    params.append("date_init", date_init);
    params.append("date_end", date_end);
  }

  if (product_ids && product_ids.length > 0) {
    params.append("product_ids", product_ids.join(","));
  }

  const queryString = params.toString();
  const url = `/order/dashboard${queryString ? `?${queryString}` : ""}`;

  const response: AxiosResponse = await axiosInstanceWebsite.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getOrderDetails = async (hash_id: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/order/${hash_id}/detail`
  );
  return response.data;
};

export const putOrderLogisticState = async (
  logisticState: LogisticState,
  hash_id: string | number
): Promise<boolean> => {
  const data = {
    logistic_state: logisticState,
  };

  const response: AxiosResponse = await axiosInstanceWebsite.put(
    `/order/${hash_id}/modification-hash/change_logistic_state`,
    data
  );
  if (response.status === 200) {
    return true;
  }
  return false;
};

export const downloadOrders = async (data: { order_ids: number[] }) => {
  const token = decodeTokenService.getToken();
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/order/export-csv`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const downloadAllOrders = async () => {
  const token = decodeTokenService.getToken();
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/order/export-csv`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const confirmDropiAfterWhatsApp = async (orderId: number) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/order/integration/dropi/confirm-whatsapp/${orderId}`
  );
  return response.data;
};

export interface UpdateOrderCustomerData {
  name?: string;
  lastName?: string;
  phone?: string;
  address?: string;
  addressDetail?: string;
  city?: string;
  department?: string;
  neighborhood?: string;
  source?: string;
}

export const updateOrderCustomer = async (
  orderId: number,
  data: UpdateOrderCustomerData
) => {
  const response: AxiosResponse = await axiosInstanceWebsite.put(
    `/order/${orderId}/modification/update_customer`,
    data
  );
  return response.data;
};

export const retryShopifyOrder = async (orderId: number) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/order/integration/shopify/retry/${orderId}`
  );
  return response.data;
};

export const retryDropiOrder = async (orderId: number) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/order/integration/dropi/retry/${orderId}`
  );
  return response.data;
};

export const retryFailedShopifyOrders = async (limit = 25) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/order/integration/shopify/retry-failed?limit=${limit}`
  );
  return response.data;
};

export const deleteOrder = async (orderId: number) => {
  const response: AxiosResponse = await axiosInstanceWebsite.delete(
    `/order/${orderId}`
  );
  return response.data;
};
